module.exports = __webpack_public_path__ + "static/media/aeur.1e7c1382.svg";